/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { formatPrice } from '../utils/helpers';

export const CartPrice = ({
  pricing,
  quantity
}) => {

  return (
    <div
      data-automation-id="atc-product-price"
      className={`sui-font-bold ${quantity ? 'sui-pt-2' : 'sui-pt-1'}`}
    >
      <div>{formatPrice(pricing?.value)}</div>
    </div>
  );
};

CartPrice.propTypes = {};

CartPrice.displayName = 'CartPrice';

CartPrice.defaultProps = {};
